import React, { Fragment } from "react";
import { Divider, useMediaQuery, useTheme } from "@material-ui/core";

import { MenuOption } from "../MenuOption/MenuOption";
import { newMenuStyles } from "./new-menu.styles";

import { Banner } from "../Banner";
import usePricingModal from "../../hooks/usePricingModal";
import { useMenuOptions } from "./useMenuOptions";
import { ProfileOption } from "../MenuOption/profile-option";

interface NewMenuProps {
  onClickMenuOption: () => void;
  setScreen: (screen: string[]) => void;
}

export const NewMenu = ({ onClickMenuOption, setScreen }: NewMenuProps) => {
  const classes = newMenuStyles();
  const theme = useTheme();
  const smallDown = useMediaQuery(theme.breakpoints.down("sm"));
  const isXsSize = useMediaQuery(theme.breakpoints.down("xs"));

  const { modalComponent, togglePricingModal } = usePricingModal();
  const options = useMenuOptions();

  const onHandleClick = (optionOnClick, disabled) => {
    if (!disabled) {
      onClickMenuOption?.();
      optionOnClick?.();
    } else togglePricingModal();
  };

  return (
    <div className={classes.menuContainer} data-testid="menus">
      {isXsSize && <ProfileOption setScreen={setScreen} />}
      {options
        .filter((option) => option.menu === "main")
        .map((option) => (
          <Fragment key={option.text}>
            <MenuOption
              data-testid={option.text}
              key={option.text}
              menuOption={option}
              onClick={() => onHandleClick(option.onClick, option.disabled)}
            />
            {option.divider && smallDown && <Divider />}
          </Fragment>
        ))}
      <Banner onClick={togglePricingModal} />
      {modalComponent}
    </div>
  );
};
